import Menu from '@/components/Menu';
import JournalEntries from '../components/JournalEntries';

import Writer from '../components/Writer';
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@/state/store';
import { loadDecks } from '@/state/features/app';
import Decks from '@/components/Decks';
import SRSCards from '@/components/SRSCards';

export default function Index() {
    const dispatch = useAppDispatch();
    const showDecksView = useAppSelector((state) => state.app.showDecksView);
    
    useEffect(() => {
        dispatch(loadDecks());
    }, []);
    
    return (
        <>
            <Menu />
            <div
                style={{
                    width: '85%',
                    maxWidth: '800px',
                    margin: '0 auto',
                }}
            >
                <Writer />
                <JournalEntries />
            </div>
            {showDecksView && <Decks />}
            <SRSCards />
        </>
    );
}
